import { GetContrastColorBW } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useProject } from "../..";
import { Project } from "../../../../../js/parsegenerated";
import { useTicketData } from "../../../_shared";
import { getProjectIcon } from "../../functions/getProjectIcon";

type Props = {
  project?: Project;
  clickable?: boolean;
};

export const ProjectTag = observer((props: Props) => {
  if (props.project) return <ProjectTagDefault {...props} />;
  return <ProjectTicketTag clickable={props.clickable} />;
});

const ProjectTicketTag = observer((props: { clickable?: boolean }) => {
  const t = useTranslation();
  const { project } = useTicketData();

  const title = project?.get("name") ?? t("maintenance:ticket.data.noProject");
  const color = project?.get("color") ?? undefined;
  const icon = getProjectIcon(project);

  return (
    <Tag
      color={color ?? "default"}
      icon={<Icon icon={icon} />}
      style={{
        margin: 0,
        cursor: props.clickable ? "pointer" : "default",
        color: color ? GetContrastColorBW(color) : undefined,
      }}
    >
      {title}
    </Tag>
  );
});

const ProjectTagDefault = observer((props: Props) => {
  const t = useTranslation();
  const { color, icon, project } = useProject(props.project);

  const title = project?.get("name") ?? t("maintenance:ticket.data.noProject");

  return (
    <Tag
      color={color ?? "default"}
      icon={<Icon icon={icon} />}
      style={{
        margin: 0,
        cursor: props.clickable ? "pointer" : "default",
        color: color ? GetContrastColorBW(color) : undefined,
      }}
    >
      {title}
    </Tag>
  );
});
